import { BrowserRouter, Route, Routes } from 'react-router'
import NoMatch from '@/components/no-match'
import RootLayout from '@/layouts/root'
import AboutPage from '@/pages/about'
import { HomePage } from '@/pages/home'

export const AppRouter = () => {
  return (
    <BrowserRouter basename={import.meta.env?.__BASENAME__ || ''}>
      <Routes>
        <Route path='/' element={<RootLayout />}>
          <Route index element={<HomePage />} />
          <Route path='about' element={<AboutPage />} />
        </Route>
        <Route path='*' element={<NoMatch />} />
      </Routes>
    </BrowserRouter>
  )
}
